/* DCG V3.1.0 · 17 OCT 2026 · the decisions round (D-SP-32 LOCKED with one change; Cole, 17 OCT; REPORT-V3-1-0-final §7.3 (b)): no stock badge while a card's button is out of stock (a sold-out card; an out-of-stock condition picked); "N left" and "In stock" as before */
/* DCG V3.1.0 · 17 OCT 2026 · item 10 (the rename round; Cowork's audit of 17 OCT): StorePass's picture link on each card, a picture with no words, is named with the card (52 to 56 unnamed links on a collection page) */
/* DCG V3.1.0 · 17 OCT 2026 · item 0 (D-SP-41 amended, LOCKED, Cole 17 OCT): no wishlist heart on any card: the guard no longer adds .dcg-wishlist-wrap (the card dress, the coming-soon row) and its wishlist helpers and click handler are gone; the wishlist lives on the product page (shop.js) and /pages/wishlist, as before */
/* DCG v2-10-13 · 16 OCT 2026 · item 4a: ?sort=created-desc leaves as "Recently Added" (SORT_LABELS); item 4b (D-SP-29 amended): a failed count call of the guard's own is announced as failed, for the count line; item 3: an event tagged retail reads "Register in store" in its notice, a retail product that is not an event "In-store only" as before */
/* DCG v2-10-12 · 16 OCT 2026 · item 4 (D-SP-40, PROPOSED): a retail card gets no stock badge ("Out of stock", "N left"), whatever its inventory */
/* DCG v2-10-11 · 16 OCT 2026 · item 1a (D-SP-39, PROPOSED): the set chosen in the panel put back into storepass.js's own Sort / In Stock Only / price search on the way out (it sends set_name empty); item 2 (a D-SP-38 defect): a count only for a search of the listing's own shape (product_line, shopify_collection_id, the listing's page size), never the header's suggestions; item 3: in_stock=undefined leaves as in_stock=true; item 6: names on each card's quantity buttons, quantity box and condition select */
/* DCG v2-10-10 · 15 OCT 2026 · item 1 (D-SP-38, PROPOSED): StorePass's 14 OCT contract. SORT_LABELS: a short sort name (alpha-asc, price-asc, ...) leaves as its label; a page answer that counts only itself, with no count request of storepass.js's own beside it, is counted by the guard (with_count=true&no_track=true, once a search) and announced for the count line and the pager; the answer itself untouched */
/* DCG v2-10-8 · 15 OCT 2026 · item 2: no in-stock-first reorder under "Price: Low-High" and "Price: High-Low" (the setting StorePass reads is set as each search leaves); item 3a: each answer is announced with its products' keys, its address and whether it is a cursor; quietSearch() for the safety net's one check of page 2 (not announced) */
/* DCG v2-10-4 · 13 OCT 2026 · every search is announced when it starts and when it fails (no answer in 8 s, a refusal, a network error), for the collection safety net (D-SP-37, PROPOSED); the condition row on every card (item 1) */
/* DCG v2-9-1 · 10 OCT 2026 · every search answer announced with its request, for the count line and the pager (D-SP-29); D-SP-10, D-SP-14, card dress (the condition label wraps, v2-8-1); result product types for the filter panel (D-SP-17); the Printing bridge: tag added to StorePass's search request, card opened on the printing (D-SP-22, D-SP-23) */
/* =========================================================
   Desert City Games — StorePass results guard (D-SP-10)
   File: assets/dcg-storepass-guard.js

   StorePass (assets/storepass.js, vendor, never edited) draws the product
   cards on collection and search pages and adds to cart with its own
   fetch("/cart/add.js"). It checks stock only, so the DCG rules that live in
   dcg-product-card.js / dcg-cart-bridge.js never run there. This file puts
   them back from the outside:

     §A  Tag map        — reads StorePass's own /saas/search responses (clone)
     §B2 Card dress     — every card gets what the DCG card has and CSS
                           cannot make from StorePass's markup: the stock pip
                           beside the condition control, the condition shown
                           without its price, and the image stage for a
                           single or a sealed product (DCG v2-6-2; the
                           wishlist heart until V3.1.0)
     §B  Card decoration — retail / coming-soon cards look like DCG cards
                           (port of dcg-product-card.js BRANCH 1 + BRANCH 2
                           and its "Retail Only" image badge, step 3b);
                           a card whose selected variant is $0.00 reads
                           "Price pending" with no cart controls (D-SP-14)
     §C  Click backstop — StorePass's /cart/add.js is blocked for retail,
                           coming-soon and $0.00 variants (D-SP-14), limit:N
                           is pre-flighted, cart refreshed
     §D  Card-style tripwire — warns if StorePass's card style is not
                           "modern-simple"; never sends a /cart.php request

   Load order: deferred, immediately BEFORE storepass.js, so window.fetch is
   wrapped before StorePass makes its first call. dcg-utils.js and
   dcg-cart-enforcer.js are deferred in <head> and have already run.

   Nothing here may throw into StorePass: every wrapped call returns the
   upstream promise or a real Response.
========================================================= */
(() => {
  'use strict';

  window.DCG = window.DCG || {};
  // One wrap per page, even if the tag is included twice.
  if (window.DCG.storepassGuard || typeof window.fetch !== 'function') return;

  // ── StorePass markup this file relies on (storepass.js "modern-simple"
  //    card). Read from the bundle, not from a rendered page — check these on
  //    the draft theme before trusting the decoration.
  const LISTING_ID       = 'product-listing-container';
  const CARD_SELECTOR    = '.store-pass-product';
  const LINK_SELECTOR    = 'a[href*="/products/"]';
  const CTA_SELECTOR     = '.store-pass-product-cta';
  const CONTROL_SELECTOR = [
    CTA_SELECTOR,                                   // add-to-cart button
    '.store-pass-product-quantity-section',         // − [qty] +
    '.store-pass-product-variant-button-section',   // variant buttons
    '.store-pass-product-select-area'               // variant <select> (condition_style: dropdown)
  ].join(', ');
  // Price pending (D-SP-14) hides less: the variant <select> stays, so the
  // customer can switch to a priced condition.
  const PRICE_CONTROL_SELECTOR = [
    CTA_SELECTOR,
    '.store-pass-product-quantity-section'
  ].join(', ');
  const SELECT_SELECTOR  = '.store-pass-product-select-area select';
  const MEDIA_SELECTOR   = '.store-pass-product-image-container';
  const INFO_SELECTOR    = '.store-pass-product-info';
  const TITLE_SELECTOR   = '.store-pass-product-title';

  // Marks left on the cards. Attributes, not classes: React owns className on
  // these nodes and never touches attributes it doesn't know about.
  const STATE_ATTR  = 'data-dcg-guard';          // on the card: retail | retail-preorder | coming-soon | price-pending
  const HANDLE_ATTR = 'data-dcg-guard-handle';   // on the card: product the decoration was built for
  const NODE_ATTR   = 'data-dcg-guard-node';     // on every node this file inserts
  const HIDDEN_ATTR = 'data-dcg-guard-hidden';   // on every StorePass control this file hides
  // §B2 (card dress) keeps its own marks, so the rule-state code above never removes its nodes.
  const DRESS_ATTR  = 'data-dcg-dress';          // on every node §B2 inserts
  const MEDIA_ATTR  = 'data-dcg-media';          // on the card: single | sealed
  const STOCK_SELECTOR       = '.store-pass-product-inventory-quantity';   // StorePass's "N left"
  const SELECT_AREA_SELECTOR = '.store-pass-product-select-area';
  const OOS_CLASS            = 'store-pass-product-tag-oos';               // on the button: selected variant has no stock

  const upstreamFetch = window.fetch;

  // ── Helpers ───────────────────────────────────────────────────────────────

  // "/products/<handle>" from any product URL StorePass builds: absolute,
  // root-relative, or "/collections/<c>/products/<handle>" on collection pages.
  function handleFromUrl(url) {
    if (!url) return null;
    let path;
    try { path = new URL(String(url), window.location.origin).pathname; }
    catch (_) { path = String(url); }
    const m = path.match(/\/products\/([^/?#]+)/);
    if (!m) return null;
    let handle = m[1];
    try { handle = decodeURIComponent(handle); } catch (_) {}
    return handle.toLowerCase() || null;
  }

  // Same-origin product page path from the form's sections_url, or null.
  function productPagePath(url) {
    try {
      const u = new URL(String(url), window.location.origin);
      if (u.origin !== window.location.origin) return null;
      return handleFromUrl(u.pathname) ? u.pathname + u.search : null;
    } catch (_) { return null; }
  }

  // Matches [YYYY-MM-DD] and formats as "May 22, 2026"
  // (same as dcg-product-card.js extractReleaseDate).
  function extractReleaseDate(titleText) {
    const m = (titleText || '').match(/\[(\d{4})-(\d{2})-(\d{2})\]/);
    if (!m) return null;
    try {
      const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
      return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    } catch (_) { return null; }
  }

  // retail > coming-soon, same tests as dcg-product-card.js (case-insensitive,
  // whole tag). retail always wins; pre-order only changes the retail wording.
  function ruleState(tags) {
    const has = name => tags.some(t => t.toLowerCase() === name);
    if (has('retail')) return has('pre-order') ? 'retail-preorder' : 'retail';
    if (has('coming-soon')) return 'coming-soon';
    return '';
  }

  // ── Price pending (D-SP-14) ───────────────────────────────────────────────
  // A variant priced 0 cannot be ordered; products tagged `event-ticket` are
  // exempt (free events). Same rule and message as dcg-cart-enforcer.js §3b.
  const PRICE_PENDING_MESSAGE = "Price pending - this item isn't available to order yet.";

  // cents: whole number, or null when the price is not known.
  function pricePending(cents, tags) {
    return cents === 0 && !tags.some(t => t.toLowerCase() === 'event-ticket');
  }

  function blockMessage(state, title) {
    if (state === 'retail-preorder') return 'Pre-order in-store — contact us to pre-order this item.';
    if (state === 'retail') return 'In-store only — contact us to purchase this item.';
    const releaseDate = extractReleaseDate(title);
    return releaseDate
      ? 'Coming soon — releasing ' + releaseDate + '.'
      : 'Coming soon — this item can’t be ordered yet.';
  }

  function toast(message) {
    try {
      const enforcer = window.DCG.enforcer;
      if (enforcer && typeof enforcer.showToast === 'function') {
        enforcer.showToast(message);
        return;
      }
    } catch (_) {}
    console.warn('[DCG guard] ' + message);
  }

  // Shaped like Shopify's own /cart/add.js error so any caller can read it.
  function blockedResponse(status, description) {
    return new Response(
      JSON.stringify({ status: status, message: 'Cart Error', description: description }),
      {
        status: status,
        statusText: { 404: 'Not Found', 422: 'Unprocessable Entity', 503: 'Service Unavailable' }[status] || '',
        headers: { 'Content-Type': 'application/json; charset=utf-8' }
      }
    );
  }

  // ═════════════════════════════════════════════════════════════════════════
  // §A  TAG MAP
  // handle → { handle, productId, title, tags: string[] | null,
  //            variantIds: Set<string>, variantPrices: Map<string, cents> }
  // tags stays null until a source actually supplies them: StorePass's header
  // search asks for a short field list, and "no tags sent" must not read as
  // "product has no tags". variantPrices holds only the prices a source sent
  // (StorePass: variantInfo[].price, in dollars; kept here in cents).
  // ═════════════════════════════════════════════════════════════════════════

  const productsByHandle  = new Map();
  const handleByVariantId = new Map();   // String(variantId) → handle
  const handleByProductId = new Map();   // String(productId) → handle

  function normaliseTags(raw) {
    if (Array.isArray(raw)) return raw.map(t => String(t).trim()).filter(Boolean);
    if (typeof raw === 'string') return raw.split(',').map(t => t.trim()).filter(Boolean);
    return null;
  }

  // Records one product from a StorePass search response (url, display_name,
  // tags, variantInfo). Only StorePass's index goes into this map. What Shopify
  // says at click time is kept apart: shopifyProducts (§C) and clickOverrides (§B).
  function recordProduct(p) {
    if (!p || typeof p !== 'object') return null;
    const handle = handleFromUrl(p.url) || (p.handle ? String(p.handle).toLowerCase() : null);
    if (!handle) return null;

    let entry = productsByHandle.get(handle);
    if (!entry) {
      entry = { handle: handle, productId: '', title: '', tags: null, variantIds: new Set(), variantPrices: new Map(), variantTitles: new Set() };
      productsByHandle.set(handle, entry);
    }

    // Shopify product id (StorePass sends it as product_id): the click backstop finds a card's handle by it (§C).
    if (p.product_id != null) {
      entry.productId = String(p.product_id);
      handleByProductId.set(entry.productId, handle);
    }

    // display_name is the Shopify product title, "[YYYY-MM-DD]" suffix included.
    // StorePass's `name` field is never used: it strips the brackets, so the
    // release date can't be read from it.
    if (p.display_name) entry.title = String(p.display_name);
    // v2-10-13 (item 3): the product type, which tells an event ("Events", "Events - <game>")
    if (p.productType || p.product_type) entry.productType = String(p.productType || p.product_type);

    const tags = normaliseTags(p.tags);
    if (tags) entry.tags = tags;

    const variants = Array.isArray(p.variantInfo) ? p.variantInfo
      : (Array.isArray(p.variants) ? p.variants : []);
    variants.forEach(v => {
      if (!v || v.id == null) return;
      const id = String(v.id);
      entry.variantIds.add(id);
      if (v.title) entry.variantTitles.add(String(v.title));
      handleByVariantId.set(id, handle);
      // StorePass sends the variant price as a number of dollars (0.41, 0).
      const dollars = (v.price === null || v.price === undefined || v.price === '') ? NaN : Number(v.price);
      if (Number.isFinite(dollars) && dollars >= 0) entry.variantPrices.set(id, Math.round(dollars * 100));
    });

    return entry;
  }

  // DCG v2-7 (D-SP-17): which Shopify product types a search answer holds
  // ("One Piece Single", "MTG Single" …). dcg-storepass-filters.js uses it to
  // know which game a page of results is. Only an answer with products in it
  // is announced (a count answer and a value-list answer have none; a value
  // list's entries have no url). StorePass leaves the type empty for some
  // products (Digimon singles, 09 OCT): then `productTypes` is empty and
  // `products` still says how many there were.
  let lastResults = { productTypes: [], products: 0 };
  function announceResultTypes(products) {
    try {
      const types = [];
      let count = 0;
      (Array.isArray(products) ? products : []).forEach(p => {
        if (!p || typeof p !== 'object' || !p.url) return;
        count++;
        const t = p.productType || p.product_type;
        if (t && types.indexOf(String(t)) === -1) types.push(String(t));
      });
      if (!count) return;
      lastResults = { productTypes: types, products: count };
      document.dispatchEvent(new CustomEvent('dcg:storepass-results', { detail: { productTypes: types.slice(), products: count } }));
    } catch (_) { /* never into StorePass */ }
  }

  // DCG v2-9-1: every search answer is also announced with the request it
  // answers, for assets/dcg-storepass-paging.js (the count line and the
  // pager). StorePass's listing sends two requests for a page of results: the
  // products, and the same request again with with_count=true, whose answer
  // holds the count. A value-list answer (return_type=...) is not announced.
  const productKey = p => String((p && (p.product_id || p.id || p.handle || p.url)) || '');
  function announceSearch(url, data, extra) {
    try {
      if (!url || !url.searchParams || url.searchParams.get('return_type')) return;
      const query = {};
      url.searchParams.forEach((v, k) => { query[k] = v; });
      document.dispatchEvent(new CustomEvent('dcg:storepass-search', { detail: {
        query: query,
        isCount: url.searchParams.get('with_count') === 'true',
        products: Array.isArray(data.products) ? data.products.length : 0,
        count: typeof data.count === 'number' ? data.count : null,
        estimate: data.countEstimate === undefined || data.countEstimate === null ? null : String(data.countEstimate),
        pages: typeof data.pages === 'number' ? data.pages : null,
        // v2-10-8 (item 3a): which products the page holds, and whether the reply is a cursor (StorePass's
        // dashboard switch "Use Shopify for initial collection results" on), for the safety net's page-2 check
        ids: Array.isArray(data.products) ? data.products.map(productKey) : [],
        endpoint: url.origin + url.pathname,
        cursor: !!(data.nextPageParameters && data.nextPageParameters.page_info),
        byGuard: !!(extra && extra.byGuard)     // v2-10-10: a count the guard asked for itself (completeCount)
      } }));
    } catch (_) { /* never into StorePass */ }
  }

  // DCG v2-10-4 (item 6; D-SP-37, PROPOSED): the collection safety net
  // (assets/dcg-collection-fallback.js) shows Shopify's own listing of a
  // collection when StorePass's search has nothing for it, or cannot be
  // reached. It needs to know, of every search StorePass's listing makes:
  // that it has started ("dcg:storepass-search-start"), what it answered
  // ("dcg:storepass-search", above), and that it failed
  // ("dcg:storepass-search-failed"): the request was refused by the network,
  // the answer was not a 200, the answer could not be read, or no answer
  // came within 8 seconds (`reason`: network, status, unreadable, timeout).
  // The guard only says so. It decides nothing, and StorePass's own request
  // and answer are neither changed nor delayed. A value-list request
  // (return_type=...) is not a search of the listing and is not announced.
  const SEARCH_PATIENCE = 8000;
  function announceSearchEvent(name, url, extra) {
    try {
      if (!url || !url.searchParams || url.searchParams.get('return_type')) return;
      const query = {};
      url.searchParams.forEach((v, k) => { query[k] = v; });
      const detail = { query: query, isCount: url.searchParams.get('with_count') === 'true' };
      if (extra) Object.keys(extra).forEach(k => { detail[k] = extra[k]; });
      document.dispatchEvent(new CustomEvent(name, { detail: detail }));
    } catch (_) { /* never into StorePass */ }
  }
  // One search, from its start: returns what to call when it is answered or fails.
  function watchSearch(url) {
    let done = false;
    announceSearchEvent('dcg:storepass-search-start', url);
    const timer = setTimeout(() => {
      if (done) return;
      done = true;
      announceSearchEvent('dcg:storepass-search-failed', url, { reason: 'timeout', status: null });
    }, SEARCH_PATIENCE);
    return {
      answered: res => {
        done = true;
        clearTimeout(timer);
        if (!res || !res.ok) announceSearchEvent('dcg:storepass-search-failed', url, { reason: 'status', status: res ? res.status : null });
      },
      failed: () => {
        if (done) return;
        done = true;
        clearTimeout(timer);
        announceSearchEvent('dcg:storepass-search-failed', url, { reason: 'network', status: null });
      }
    };
  }

  // `res` is a clone; StorePass keeps the original, untouched and undelayed.
  function recordSearchResponse(res, url) {
    // v2-10-4: a 200 whose body is not JSON is a failed search too
    const unreadable = () => { if (res && res.ok) announceSearchEvent('dcg:storepass-search-failed', url, { reason: 'unreadable', status: res.status }); return null; };
    res.json().then(data => data, unreadable).then(data => {
      if (!data || typeof data !== 'object') return;
      [data.products, data.additional_products].forEach(list => {
        if (Array.isArray(list)) list.forEach(recordProduct);
      });
      announceResultTypes(data.products);
      announceSearch(url, data);
      try { if (needsCount(url, data)) completeCount(url); } catch (_) {}   // v2-10-10 (item 1b)
      scheduleDecorate();
    }).catch(() => {});
  }

  // DCG v2-10-10 (item 1; D-SP-38, PROPOSED): StorePass's 14 OCT contract.
  // Since then StorePass's page answer gives count = the products it holds
  // and pages 1, and the whole search is counted only by the same request
  // with with_count=true&no_track=true (docs/REPORT-v2-10-10.md §1). The
  // storepass.js we have sends that request itself beside every page of the
  // listing (not for StorePass's "products_only" grids, nor when a
  // collection's first page comes from Shopify). So the guard asks for the
  // count only when a page answer looks like the page alone (count ==
  // products.length, pages <= 1) and no count request for the same search
  // and page has left: once a search, the answer kept for the page, and
  // announced as a count answer of that page, as storepass.js's own would
  // be, for the count line and the pager (assets/dcg-storepass-paging.js;
  // D-SP-29 unchanged). The page answer itself is never held or changed:
  // storepass.js draws the cards at once. A count call that fails, is not a
  // 200 or has no answer in 8 s was announced as nothing until v2-10-13 (the
  // count line then stood aside, StorePass's own showing); it is now
  // announced as a failed count (below), and the count line puts up the
  // page's own range with Previous / Next and no total (D-SP-29 amended).
  // Never on a value-list search (return_type), never on a search with no
  // sort.
  // DCG v2-10-11 (item 2): and only on a search of the listing's own shape:
  // it names a product line and a collection and asks for the listing's
  // page size (search_limit in the settings storepass.js reads). The
  // header's suggestions (name=…&limit=12&sort=Relevance, with neither)
  // carry a sort, so v2-10-10 counted them, and their pair took over the
  // count line and the pager: "Showing 1-53 of 255" on Advanced Search
  // after "charizard" in the header, "1-60 of 471" on Riftbound after
  // "luffy" (Cowork, 16 OCT 05:50Z).
  const PASSIVE_KEYS = ['page', 'skip', 'with_count', 'no_track', 'shopify_page_parameters'];
  function searchKey(url) {
    const keys = [];
    url.searchParams.forEach((v, k) => { if (PASSIVE_KEYS.indexOf(k) === -1) keys.push(k + '=' + v); });
    return keys.sort().join('&');
  }
  const pageKey = url => searchKey(url) + '|' + (url.searchParams.get('page') || url.searchParams.get('skip') || '1');
  const countsAsked = new Set();         // pageKey of every count request storepass.js sent
  const guardCounts = new Map();         // searchKey -> Promise of the count answer (or null)
  const keep = (store, k) => { if (store.size > 40) store.delete(store.keys().next().value); return k; };
  // the listing's page size, as storepass.js takes it: a limit in the page's address (its own push writes one:
  // limit=60), or else search_limit in the settings it reads (its own default 24 when there is none); null when
  // neither is known yet
  function listingSize() {
    const asked = parseInt(new URLSearchParams(window.location.search).get('limit'), 10);
    if (asked > 0) return asked;
    if (!spSearchSettings) return null;
    const n = parseInt(spSearchSettings.search_limit, 10);
    return n > 0 ? n : 24;
  }
  function listingShaped(url) {
    const p = url.searchParams, size = listingSize();
    return !!p.get('product_line') && !!p.get('shopify_collection_id') && size !== null && parseInt(p.get('limit'), 10) === size;
  }
  function needsCount(url, data) {
    if (!url || !url.searchParams || url.searchParams.get('return_type') || url.searchParams.get('with_count') === 'true') return false;
    if (!url.searchParams.get('sort')) return false;
    if (!listingShaped(url)) return false;                                // v2-10-11 (item 2): never the header's suggestions
    const n = Array.isArray(data.products) ? data.products.length : 0;
    if (!n || data.count !== n || data.pages > 1) return false;          // an exact answer is left alone
    return !countsAsked.has(pageKey(url));                               // storepass.js asked for it itself
  }
  function countCall(href) {
    return new Promise(resolve => {
      let done = false;
      const end = v => { if (!done) { done = true; resolve(v); } };
      setTimeout(() => end(null), SEARCH_PATIENCE);
      let pending;
      try { pending = upstreamFetch.call(window, href); } catch (_) { end(null); return; }
      pending.then(res => (res && res.ok ? res.json() : null)).then(data => {
        end(data && typeof data === 'object' && typeof data.count === 'number' ? data : null);
      }, () => end(null));
    });
  }
  const countUrlOf = url => { const c = new URL(url.href); c.searchParams.set('with_count', 'true'); c.searchParams.set('no_track', 'true'); return c; };
  function completeCount(url) {
    const asked = countUrlOf(url);
    const key = searchKey(url);
    let answer = guardCounts.get(key);
    if (!answer) {
      answer = countCall(asked.href);
      guardCounts.set(keep(guardCounts, key), answer);
      answer.then(a => { if (!a && guardCounts.get(key) === answer) guardCounts.delete(key); });   // a later page may ask again
    }
    // DCG v2-10-13 (item 4b; D-SP-29 amended, LOCKED by Cole, 16 OCT 07:20Z): a count call of the guard's own that
    // fails (no answer in 8 s, not a 200, no count in it) is announced as failed, as storepass.js's own count request
    // is (watchSearch), so the count line puts up "Showing 1-60" with Previous / Next and no total. The safety net
    // takes no failed count for its own: this call leaves only after the page answer has come with products.
    answer.then(a => {
      if (a) announceSearch(asked, { count: a.count, countEstimate: a.countEstimate, pages: a.pages, current_page: a.current_page }, { byGuard: true });
      else announceSearchEvent('dcg:storepass-search-failed', asked, { reason: 'count', status: null, byGuard: true });
    });
  }

  // DCG v2-10-10 (item 1a): the sort, outgoing. StorePass's search takes the
  // sort by its label since the 14 OCT release; the short names fall to its
  // default order. storepass.js sends a label for every sort it chooses
  // itself (its sort control; a collection's own sort_order through its map
  // of names to labels; "Relevance" for a name search), but a sort written
  // in the page's address (?sort=...) goes as it is written. So a short name
  // is sent as its label. Every other value, "Relevance", "Sales",
  // "Recently Added" and every label among them, goes unchanged.
  // DCG v2-10-13 (item 4a; LOCKED by Cole, 16 OCT 07:20Z): created-desc goes as
  // "Recently Added", the label storepass.js's own map gives it (and its sort
  // control and the safety net use), not "Release Date: New-Old" (v2-10-10's).
  const SORT_LABELS = {
    'alpha-asc':    'Alphabetical: A-Z',
    'alpha-desc':   'Alphabetical: Z-A',
    'price-asc':    'Price: Low-High',
    'price-desc':   'Price: High-Low',
    'created-desc': 'Recently Added'
  };
  // DCG v2-10-11 (item 3): in_stock, outgoing, in the same place. storepass.js's
  // own "In Stock Only" link calls its handler with nothing, so its state
  // holds undefined and its request says in_stock=undefined, the word (the
  // plain request and the count request; off, it sends in_stock= empty).
  // StorePass's search takes any value but an empty one as "in stock" (16
  // OCT: Riftbound singles, page 1 under A-Z, the same 60 cards in the same
  // order, all in stock, for "undefined" and for "true"; 31 in stock of 60
  // with it off; docs/img/v2-10-11/in-stock-probe.txt), and a stricter
  // reading would drop the filter without a sign. It leaves as
  // in_stock=true. The theme reads in_stock only from the address and from
  // StorePass's pill, never from the request.
  function labelledSearchUrl(input) {
    if (typeof input !== 'string' && !(typeof URL !== 'undefined' && input instanceof URL)) return null;   // a Request object is left alone
    const url = new URL(String(input), window.location.href);
    let changed = false;
    const sort = url.searchParams.get('sort');
    if (sort !== null && Object.prototype.hasOwnProperty.call(SORT_LABELS, sort)) { url.searchParams.set('sort', SORT_LABELS[sort]); changed = true; }
    if (url.searchParams.get('in_stock') === 'undefined') { url.searchParams.set('in_stock', 'true'); changed = true; }
    return changed ? url.toString() : null;
  }

  // ═════════════════════════════════════════════════════════════════════════
  // §B  CARD DECORATION
  // Port of dcg-product-card.js BRANCH 1 (retail), BRANCH 2 (coming soon) and
  // step 3b (Retail Only image badge) onto StorePass's card. Controls are
  // hidden, never removed, and every inserted node carries NODE_ATTR, so a
  // pass over an already-decorated card changes nothing.
  // ═════════════════════════════════════════════════════════════════════════

  // Click-time overrides: handle → Shopify's product, set by §C when a click
  // finds Shopify calls a product retail or coming-soon and StorePass's index
  // doesn't say the same, or (D-SP-14) Shopify prices the clicked variant at
  // $0.00 and the index doesn't. Decoration reads this list first, then the
  // tag map, so that card gets its notice at once and keeps it through
  // re-renders and new search responses. The tag map itself is never written
  // with it.
  const clickOverrides = new Map();

  function productForCard(handle) {
    return clickOverrides.get(handle) || productsByHandle.get(handle) || null;
  }

  function hideControls(card, selector) {
    card.querySelectorAll(selector).forEach(el => {
      if (el.hasAttribute(HIDDEN_ATTR) && el.style.display === 'none') return;
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute(HIDDEN_ATTR, '');
    });
  }

  // Undo everything this file did to a card (product behind the node changed,
  // or its tags no longer call for a notice).
  function clearCard(card) {
    if (!card.hasAttribute(STATE_ATTR)) return;
    card.querySelectorAll('[' + NODE_ATTR + ']').forEach(el => {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    card.querySelectorAll('[' + HIDDEN_ATTR + ']').forEach(el => {
      el.style.removeProperty('display');
      el.removeAttribute(HIDDEN_ATTR);
    });
    card.removeAttribute(STATE_ATTR);
    card.removeAttribute(HANDLE_ATTR);
  }

  // Notices take the add-to-cart button's place: directly after it when the
  // card has one, otherwise at the end of the info column.
  function placeInCard(card, node) {
    const cta = card.querySelector(CTA_SELECTOR);
    if (cta && cta.parentNode) {
      cta.parentNode.insertBefore(node, cta.nextSibling);
    } else {
      (card.querySelector(INFO_SELECTOR) || card).appendChild(node);
    }
  }

  // ── Retail Only badge (dcg-product-card.js step 3b, :225-236) ─────────────
  // On the image of every card whose product has the `retail` tag, which is
  // every card in a retail state here (ruleState). Its rule is copied into
  // dcg-storepass.css.
  function addRetailBadge(card) {
    const media = card.querySelector(MEDIA_SELECTOR);
    if (!media || media.querySelector('.dcg-retail-badge')) return;
    const rb = document.createElement('div');
    rb.className = 'dcg-retail-badge';
    rb.setAttribute(NODE_ATTR, '');
    rb.textContent = 'Retail Only';
    media.appendChild(rb);
  }

  // ── BRANCH 1: Retail — always wins, cart always disabled ──────────────────
  // DCG v2-10-13 (item 3; Cole, 16 OCT, §8 14:00Z: "Register in store · Contact us" on event cards everywhere;
  // non-event retail products keep "In-store only · Contact us"): an event is a product tagged event-ticket or whose
  // type is "Events" / "Events - <game>" (docs/EVENTS-DATA-CONTRACT.md; every product of the events collection is
  // one). dcg-product-card.js tells it the same way.
  function isEvent(product) {
    if (!product) return false;
    const tags = Array.isArray(product.tags) ? product.tags : normaliseTags(product.tags) || [];
    if (tags.some(t => String(t).toLowerCase() === 'event-ticket')) return true;
    return /^events?\b/i.test(String(product.productType || product.product_type || product.type || '').trim());
  }
  function addRetailNotice(card, state, product) {
    if (card.querySelector('.dcg-retail-notice[' + NODE_ATTR + ']')) return;

    const retailNotice = document.createElement('div');
    retailNotice.className = 'dcg-retail-notice';
    retailNotice.setAttribute(NODE_ATTR, '');
    retailNotice.innerHTML =
      '<span class="dcg-retail-notice__text">' +
        (state === 'retail-preorder' ? 'Pre-order in-store' : isEvent(product) ? 'Register in store' : 'In-store only') +
      '</span>' +
      '<a href="/pages/contact" class="dcg-retail-notice__link">Contact us &rarr;</a>';

    placeInCard(card, retailNotice);
  }

  // ── Price pending (D-SP-14) ───────────────────────────────────────────────
  // The variant the card has selected, as a string id, or null if it can't
  // be told. StorePass draws the <select> only for products with more than
  // one variant; each option's value is the variant as JSON (storepass.js:
  // value: JSON.stringify(variant)). The select is uncontrolled, so its DOM
  // value is the customer's current choice.
  function selectedVariantId(card, product) {
    let id = null;
    const select = card.querySelector(SELECT_SELECTOR);
    if (select) {
      try {
        const variant = JSON.parse(select.value);
        if (variant && variant.id != null) id = String(variant.id);
      } catch (_) { /* not the markup this file was written for */ }
    } else if (product.variantIds.size === 1) {
      id = product.variantIds.values().next().value;
    }
    // A node React is re-using for another product can still hold the old
    // product's selection for a moment: only trust an id that belongs here.
    return (id && product.variantIds.has(id)) ? id : null;
  }

  function selectedVariantPricePending(card, product) {
    const id = selectedVariantId(card, product);
    if (!id || !product.variantPrices) return false;
    const cents = product.variantPrices.get(id);
    return typeof cents === 'number' && pricePending(cents, product.tags);
  }

  // Takes the place of the add-to-cart button and the quantity stepper.
  function addPriceNotice(card) {
    if (card.querySelector('.dcg-price-notice[' + NODE_ATTR + ']')) return;
    const priceNotice = document.createElement('div');
    priceNotice.className = 'dcg-price-notice';
    priceNotice.setAttribute(NODE_ATTR, '');
    priceNotice.innerHTML = '<span class="dcg-price-notice__text">Price pending</span>';
    placeInCard(card, priceNotice);
  }

  // DCG V3.1.0 (item 0; D-SP-41 amended, LOCKED): the wishlist heart's builder (buildWishlistWrap), its cookie
  // helpers, restoreWishlist and its click handler lived here. No card carries a heart now; the product page's own
  // Add To Wishlist (snippets/wishlist-product.liquid, shop.js) and /pages/wishlist are untouched, and the cookie
  // (wishlistList) is left as it is, so anything already hearted stays.

  // ── BRANCH 2: Coming Soon — no cart: the release date and Notify Me ───────
  function addComingSoon(card, product, handle) {
    const media = card.querySelector(MEDIA_SELECTOR);
    if (media && !media.querySelector('.dcg-coming-soon-badge')) {
      const csBadge = document.createElement('span');
      csBadge.className = 'dcg-coming-soon-badge';
      csBadge.setAttribute(NODE_ATTR, '');
      csBadge.textContent = 'Coming Soon';
      media.appendChild(csBadge);
    }

    if (card.querySelector('.dcg-row3--coming-soon[' + NODE_ATTR + ']')) return;

    const row3 = document.createElement('div');
    row3.className = 'dcg-card-row3 dcg-row3--coming-soon';
    row3.setAttribute(NODE_ATTR, '');

    // row3: the release date, then Notify Me (V3.1.0, item 0: the heart that began the row is gone).
    const mapped = productsByHandle.get(handle);

    // Extract release date from title: the card's own title text first, as a
    // DCG card does; StorePass's display_name from the tag map if the card
    // has no title text.
    const titleEl = card.querySelector(TITLE_SELECTOR);
    const cardTitle = titleEl ? titleEl.textContent : '';
    const titleText = cardTitle.trim() ? cardTitle : ((mapped && mapped.title) || '');
    const releaseDate = extractReleaseDate(titleText);
    if (releaseDate) {
      const csLabel = document.createElement('span');
      csLabel.className = 'dcg-coming-soon-label';
      csLabel.textContent = 'Releasing ' + releaseDate;
      row3.appendChild(csLabel);
    }

    // Deep-links to the PDP's capture component (#dcg-notify).
    const csNotifyBtn = document.createElement('button');
    csNotifyBtn.className = 'dcg-notify-btn';
    csNotifyBtn.type = 'button';
    csNotifyBtn.innerHTML = '<svg viewBox="0 0 20 20" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 2a6 6 0 0 1 6 6c0 3 1.5 4 1.5 5.5H2.5C2.5 12 4 11 4 8a6 6 0 0 1 6-6z" stroke="currentColor"/><path d="M8 15.5a2 2 0 0 0 4 0" stroke="currentColor"/></svg><span>Notify Me</span>';
    csNotifyBtn.addEventListener('click', () => {
      window.location.href = '/products/' + handle + '#dcg-notify';
    });
    row3.appendChild(csNotifyBtn);

    placeInCard(card, row3);
  }

  // ═════════════════════════════════════════════════════════════════════════
  // §B2  CARD DRESS (DCG v2-6-2)
  // The DCG card (dcg-product-card.js buildCardUI) is the template. CSS in
  // dcg-storepass.css lays StorePass's own elements out as that card's rows;
  // this section adds the four things CSS cannot make from StorePass's markup,
  // and names StorePass's controls (5). Each is a node of ours (DRESS_ATTR),
  // an attribute on the card, or (5) an aria-label on a control. None of
  // StorePass's nodes is moved, replaced or rewritten, and StorePass's button
  // stays the element that is clicked. Every step writes only when something
  // differs, so a pass over a dressed card changes nothing.
  //
  //   1. Stock pip   .dcg-stock-pip, in the same row as the condition control
  //                  (dcg-product-card.js :343-350). Its text is StorePass's
  //                  own "N left" ("In stock" where StorePass gives no
  //                  count); none when the button is out of stock (V3.1.0,
  //                  the decisions round; "Out of stock" until then).
  //   2. Condition   .dcg-cond-label, laid over the closed <select>, reading
  //                  the condition only. StorePass's option text is
  //                  "Near Mint - $0.25" and belongs to React; the open list
  //                  still shows it.
  //   3. (Heart: .dcg-wishlist-wrap between quantity and Add to Cart, until
  //      V3.1.0; D-SP-41 amended: no card carries a heart.)
  //   4. Image stage data-dcg-media on the card: "single" (dark stage,
  //                  picture edge to edge) or "sealed" (white stage, 8px
  //                  inset), by the DCG card's own test (isSingleCard).
  //   5. Names       aria-label on StorePass's quantity buttons, quantity box
  //                  and condition select (v2-10-11); nothing seen changes.
  // ═════════════════════════════════════════════════════════════════════════

  // dcg-product-card.js :193-213, unchanged. Its second list, of product
  // types, is left out: isSingleCard reads the type from data-product-type,
  // and no DCG card carries that attribute (snippets/dcg-product-card.liquid,
  // dcg-advanced-search.js), so on a real DCG card that test never applies.
  // A card is a single if a variant is a condition, or a tag says so.
  const CONDITION_PATTERNS = [
    'near mint', 'lightly played', 'moderately played', 'heavily played',
    'damaged', 'nm', 'lp', 'mp', 'hp', 'dmg',
    'graded', 'psa', 'bgs', 'cgc',
    '1st edition', 'unlimited', 'limited edition',
    'foil', 'reverse foil', 'holo', 'non-holo',
    'first edition', 'shadowless'
  ];
  const SINGLES_TAG_PATTERNS = [
    'single', 'singles', 'tcg-single', 'tcg_single',
    'magic-single', 'mtg-single', 'pokemon-single',
    'yugioh-single', 'ygo-single', 'fab-single',
    'one-piece-single', 'flesh-and-blood-single', 'riftbound-single'
  ];

  // The variants a card's <select> offers. StorePass writes each variant as
  // JSON into its option's value.
  function optionVariants(select) {
    const out = [];
    if (!select) return out;
    for (let i = 0; i < select.options.length; i++) {
      try { const v = JSON.parse(select.options[i].value); if (v && typeof v === 'object') out.push(v); } catch (_) {}
    }
    return out;
  }
  function selectedVariant(select) {
    if (!select) return null;
    try { const v = JSON.parse(select.value); return (v && typeof v === 'object') ? v : null; } catch (_) { return null; }
  }
  // Nothing left to pick: every option reads as zero stock. An option that
  // cannot be read that way counts as in stock (the same test the sold-out
  // rules in dcg-storepass.css make on the option values).
  function nothingInStock(select) {
    const variants = optionVariants(select);
    return variants.length > 0 && select.options.length === variants.length &&
      variants.every(v => typeof v.inventory_quantity === 'number' && v.inventory_quantity <= 0);
  }
  function isOutOfStock(card) {
    const cta = card.querySelector(CTA_SELECTOR);
    return !!cta && cta.classList.contains(OOS_CLASS);
  }
  // The select area carries the pip and the label unless a rule state has
  // hidden it (retail, coming-soon).
  function usableSelectArea(card, state) {
    if (state && state !== 'price-pending') return null;
    const area = card.querySelector(SELECT_AREA_SELECTOR);
    return (area && area.querySelector('select')) ? area : null;
  }
  function removeNode(node) { if (node && node.parentNode) node.parentNode.removeChild(node); }

  // 4. Image stage — dcg-product-card.js isSingleCard (:215-239).
  function dressMedia(card, product) {
    const select = card.querySelector(SELECT_SELECTOR);
    let titles = optionVariants(select).map(v => v.title);
    if (!titles.length && product && product.variantTitles) titles = Array.from(product.variantTitles);
    let kind = '';
    if (titles.some(t => { const tl = String(t || '').toLowerCase(); return CONDITION_PATTERNS.some(p => tl.includes(p)); })) {
      kind = 'single';
    } else if (product) {
      const tags = product.tags || [];
      kind = tags.some(t => SINGLES_TAG_PATTERNS.some(p => String(t).toLowerCase().includes(p))) ? 'single' : 'sealed';
    }
    if ((card.getAttribute(MEDIA_ATTR) || '') === kind) return;
    if (kind) card.setAttribute(MEDIA_ATTR, kind); else card.removeAttribute(MEDIA_ATTR);
  }

  // 1. Stock pip — pipClass / pipLabel (:155-167): 1 to 4 left is "low".
  function dressStock(card, info, state) {
    let text = '', cls = '';
    // a coming-soon DCG card shows no pip; DCG v2-10-12 (item 4; D-SP-40, PROPOSED): nor does a retail card,
    // which is bought in store only, whatever its stock (its "In-store only" row and Retail Only badge say so).
    // V3.1.0, the decisions round (D-SP-32 LOCKED with one change; Cole, 17 OCT; REPORT-V3-1-0-final §7.3 (b)):
    // nor does a card whose button is out of stock. On a sold-out card its Sold Out picture and its button say it;
    // where an out-of-stock condition is picked on a card that has stock in another, its button says it. Until then
    // the pip read "Out of stock" (grey, "no"); a card with stock keeps its "N left" or "In stock" as before.
    if (state !== 'coming-soon' && state !== 'retail' && state !== 'retail-preorder' && !isOutOfStock(card)) {
      const sp  = card.querySelector(STOCK_SELECTOR);
      const raw = sp ? sp.textContent.replace(/\s+/g, ' ').trim() : '';
      const n   = parseInt(raw, 10);
      if (raw) { text = raw; cls = (n > 0 && n <= 4) ? 'low' : 'in'; }
      else if (card.querySelector(CTA_SELECTOR)) { text = 'In stock'; cls = 'in'; }
    }
    let pip = card.querySelector('.dcg-stock-pip[' + DRESS_ATTR + ']');
    let row = info.querySelector(':scope > .dcg-card-row1[' + DRESS_ATTR + ']');
    // DCG v2-10-4 (item 1): the row is on every card, with or without a badge.
    // A card with no badge (coming soon) and no condition control keeps an
    // empty row where the others have theirs, as the DCG card does (its row 1
    // is always there, dcg-product-card.js). A card that has the control has
    // its row already: StorePass's own select area.
    if (!text) {
      removeNode(pip);
      if (usableSelectArea(card, state)) removeNode(row);
      else if (!row) {
        row = document.createElement('div');
        row.className = 'dcg-card-row1';
        row.setAttribute(DRESS_ATTR, '');
        info.insertBefore(row, info.firstChild);
      }
      return;
    }

    // Beside the condition control when the card has one. Otherwise in a row
    // of its own, where the DCG card's row 1 is (its select is hidden then).
    let target = usableSelectArea(card, state);
    if (target) { if (row) { if (pip && pip.parentNode === row) removeNode(pip), pip = null; removeNode(row); } }
    else {
      if (!row) {
        row = document.createElement('div');
        row.className = 'dcg-card-row1';
        row.setAttribute(DRESS_ATTR, '');
        info.insertBefore(row, info.firstChild);
      }
      target = row;
    }
    if (!pip) {
      pip = document.createElement('span');
      pip.className = 'dcg-stock-pip';
      pip.setAttribute(DRESS_ATTR, '');
    }
    if (pip.parentNode !== target) target.appendChild(pip);
    // in | low | no: the DCG card's s-in / s-low / s-no, as an attribute
    if (pip.getAttribute('data-dcg-stock') !== cls) pip.setAttribute('data-dcg-stock', cls);
    if (pip.textContent !== text) pip.textContent = text;
  }

  // 2. Condition label over the closed <select>.
  function dressCondition(card, state) {
    const area   = usableSelectArea(card, state);
    const select = area ? area.querySelector('select') : null;
    let label = card.querySelector('.dcg-cond-label[' + DRESS_ATTR + ']');
    const variant = selectedVariant(select);
    if (!select || !variant || !variant.title) { removeNode(label); return; }

    // dcg-product-card.js :358-363: a sold-out card's select reads "Sold out".
    const text = (isOutOfStock(card) && nothingInStock(select)) ? 'Sold out' : String(variant.title);
    if (!label) {
      label = document.createElement('span');
      label.className = 'dcg-cond-label';
      label.setAttribute(DRESS_ATTR, '');
      label.setAttribute('aria-hidden', 'true');   // the <select> itself is what is announced
    }
    if (label.parentNode !== area) area.insertBefore(label, select.nextSibling);
    if (label.textContent !== text) label.textContent = text;
    // DCG v2-8-1: the label is in the row's flow and wraps (dcg-storepass.css),
    // so it no longer needs the pip's width; the property v2-6-2 set is taken off.
    if (label.style.getPropertyValue('--dcg-pip-w')) label.style.removeProperty('--dcg-pip-w');
  }

  // 5. Names (DCG v2-10-11 item 6). StorePass's quantity − and + are buttons
  // holding a picture only, and its quantity box and condition select have
  // no label (Cowork, 16 OCT: 62 buttons, 60 selects, 60 boxes on one page).
  // Each is given a name with the card's own: aria-label only, nothing seen
  // changes. Written only when it differs, on every pass, as React redraws.
  function nameNode(node, text) {
    if (node && node.getAttribute('aria-label') !== text) node.setAttribute('aria-label', text);
  }
  function dressNames(card) {
    const title = card.querySelector(TITLE_SELECTOR);
    const name = title ? title.textContent.replace(/\s+/g, ' ').trim() : '';
    const of = name ? ' for ' + name : '';
    const qty = card.querySelector('.store-pass-product-quantity-section');
    if (qty) {
      const buttons = qty.querySelectorAll('button');
      if (buttons.length >= 2) { nameNode(buttons[0], 'Decrease quantity' + of); nameNode(buttons[buttons.length - 1], 'Increase quantity' + of); }
      nameNode(qty.querySelector('input'), 'Quantity' + of);
    }
    nameNode(card.querySelector(SELECT_SELECTOR), 'Condition' + of);
    // V3.1.0 (item 10): the picture link holds a picture drawn as a background, no words, so it had no name
    if (name) nameNode(card.querySelector('.store-pass-product-image-container a[href]'), name);
  }

  function dressCard(card, handle, product, state) {
    const info = card.querySelector(INFO_SELECTOR);
    if (!info) return;
    dressMedia(card, product);
    dressStock(card, info, state);
    dressCondition(card, state);
    dressNames(card);
  }

  function decorateCard(card) {
    const link    = card.querySelector(LINK_SELECTOR);
    const handle  = link ? handleFromUrl(link.getAttribute('href')) : null;
    const product = handle ? productForCard(handle) : null;
    try { openOnPrinting(card, handle); } catch (_) { /* the card stays on StorePass's own choice */ }
    const state   = decorateRuleState(card, handle, product);
    try { dressCard(card, handle, product, state); }
    catch (err) { console.warn('[DCG guard] card dress failed:', err); }
  }

  // Retail, coming-soon and price-pending (§B). Returns the state it left the card in.
  function decorateRuleState(card, handle, product) {
    let state     = (product && product.tags) ? ruleState(product.tags) : '';
    // Retail / coming-soon come first. Otherwise: is the selected variant $0.00?
    if (!state && product && product.tags && selectedVariantPricePending(card, product)) {
      state = 'price-pending';
    }

    const builtFor = card.getAttribute(HANDLE_ATTR) || '';
    if ((card.getAttribute(STATE_ATTR) || '') !== state || (state && builtFor !== handle)) {
      clearCard(card);
    }
    if (!state) return state;

    if (card.getAttribute(STATE_ATTR) !== state) card.setAttribute(STATE_ATTR, state);
    if (builtFor !== handle) card.setAttribute(HANDLE_ATTR, handle);

    // Re-checked on every pass: StorePass re-renders these on sort, filter,
    // paging and variant change.
    if (state === 'price-pending') {
      hideControls(card, PRICE_CONTROL_SELECTOR);
      addPriceNotice(card);
      return state;
    }
    hideControls(card, CONTROL_SELECTOR);
    if (state === 'coming-soon') {
      addComingSoon(card, product, handle);
    } else {
      addRetailBadge(card);
      addRetailNotice(card, state, product);
    }
    return state;
  }

  function decorateAll() {
    const listing = document.getElementById(LISTING_ID);
    if (!listing) return;
    listing.querySelectorAll(CARD_SELECTOR).forEach(card => {
      try { decorateCard(card); }
      catch (err) { console.warn('[DCG guard] card decoration failed:', err); }
    });
  }

  // Coalesce bursts (a StorePass render is hundreds of mutations) into one
  // pass per frame. Our own insertions re-trigger the observer once; that pass
  // finds every card already decorated and writes nothing, so it settles.
  // A hidden tab is given no animation frames, so there the pass runs on a
  // timer: decoration must not wait for the tab to be shown.
  let decorateQueued = false;
  function runDecorate() {
    if (!decorateQueued) return;   // this pass has already run
    decorateQueued = false;
    try { decorateAll(); }
    catch (err) { console.warn('[DCG guard] decoration failed:', err); }
  }
  function scheduleDecorate() {
    if (decorateQueued) return;
    decorateQueued = true;
    if (!document.hidden && typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(runDecorate);
    } else {
      setTimeout(runDecorate, 16);
    }
  }
  // A pass queued on a frame, and the tab is hidden before that frame comes:
  // run it on the timer instead. The frame, when it does come, finds nothing
  // queued.
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && decorateQueued) setTimeout(runDecorate, 16);
  });

  // Scoped to the results container only (see the observer notes in
  // dcg-cart-enforcer.js: document-wide observers pin heavy collection pages).
  function watchListing() {
    const listing = document.getElementById(LISTING_ID);
    if (!listing || typeof MutationObserver === 'undefined') return;
    new MutationObserver(scheduleDecorate).observe(listing, { childList: true, subtree: true });
    // D-SP-14: a new condition can turn "Price pending" on or off. React may
    // answer a variant change by rewriting text only, which the observer above
    // doesn't see, so the select's own change event asks for a pass too.
    // v2-6-2: the condition label (§B2) follows the select at once, on the
    // same event, so it never reads the condition that was just left.
    const onPick = e => {
      if (!e.target || !e.target.matches || !e.target.matches(SELECT_SELECTOR)) return;
      const card = e.target.closest(CARD_SELECTOR);
      if (card) { try { dressCondition(card, card.getAttribute(STATE_ATTR) || ''); } catch (_) {} }
      scheduleDecorate();
    };
    listing.addEventListener('change', onPick);
    listing.addEventListener('input', onPick);
    scheduleDecorate();
  }

  // ═════════════════════════════════════════════════════════════════════════
  // §C  CLICK BACKSTOP
  // Only StorePass posts FormData to /cart/add.js. Every DCG caller
  // (dcg-cart-bridge.js:41, top singles, events, decklist) sends a JSON string
  // and is passed straight through by the wrapper below.
  // ═════════════════════════════════════════════════════════════════════════

  // Shopify's own answer for a product, from /products/<handle>.js:
  // handle → Promise<{ handle, title, tags, variantIds, variantPrices } | null>.
  // variantPrices: Map<variantId, cents> (Shopify's .js gives cents).
  // Kept for the life of the page. A request that fails (network, non-200,
  // unusable body) resolves to null and is dropped, so the next click retries.
  const shopifyProducts = new Map();

  function fetchShopifyProduct(handle) {
    let pending = shopifyProducts.get(handle);
    if (pending) return pending;

    pending = upstreamFetch.call(window, '/products/' + encodeURIComponent(handle) + '.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(res => (res.ok ? res.json() : null)).then(data => {
      if (!data || !Array.isArray(data.tags) || !Array.isArray(data.variants)) return null;
      return {
        fromShopify: true,
        handle: handle,
        productId: data.id != null ? String(data.id) : '',
        title: String(data.title || ''),
        tags: normaliseTags(data.tags),
        variantIds: new Set(data.variants.filter(v => v && v.id != null).map(v => String(v.id))),
        variantPrices: new Map(data.variants
          .filter(v => v && v.id != null && v.price !== null && v.price !== undefined && v.price !== '' && Number.isFinite(Number(v.price)))
          .map(v => [String(v.id), Math.round(Number(v.price))]))
      };
    }).catch(() => null).then(product => {
      if (!product) shopifyProducts.delete(handle);
      return product;
    });

    shopifyProducts.set(handle, pending);
    return pending;
  }

  // Tags for the variant being added. Shopify is always asked first (the tag
  // map is StorePass's index and can lag or lack DCG's rule tags); the map is
  // used only when Shopify could not be asked. null = cannot be resolved.
  async function resolveProduct(variantId, sectionsUrl) {
    // Product URL StorePass put in the form, then the map's handle for this
    // variant if it names a different product.
    const mappedHandle = handleByVariantId.get(variantId);
    const handles = [handleFromUrl(sectionsUrl), mappedHandle]
      .filter((h, i, all) => h && all.indexOf(h) === i);

    let shopifyAnswered = false;
    for (const handle of handles) {
      const product = await fetchShopifyProduct(handle);
      if (!product) continue;
      shopifyAnswered = true;
      // The URL must really be this variant's product, or its tags prove nothing.
      if (product.variantIds.has(variantId)) return product;
    }

    // Every request failed: fall back to the tag map. If Shopify did answer
    // but the variant is in none of those products, stay unresolved.
    if (!shopifyAnswered) {
      const mapped = productsByHandle.get(mappedHandle);
      if (mapped && mapped.tags) return mapped;
    }
    return null;
  }

  // Shopify says retail / coming-soon and StorePass's index doesn't say the
  // same: put it on the override list so the card is redrawn with the notice
  // now and after every later re-render (§B reads clickOverrides first).
  function recordOverride(product, state) {
    if (!product.fromShopify) return;   // map fallback: the card already follows the map
    const mapped = productsByHandle.get(product.handle);
    const mapState = (mapped && mapped.tags) ? ruleState(mapped.tags) : '';
    if (mapState === state) return;
    clickOverrides.set(product.handle, product);
    scheduleDecorate();
  }

  // D-SP-14: Shopify prices the clicked variant at $0.00 and StorePass's index
  // doesn't (it lags, or has no price for it): same override list, so the card
  // is redrawn with "Price pending" now and after every later re-render.
  function recordPriceOverride(product, variantId) {
    if (!product.fromShopify) return;   // map fallback: the card already follows the map
    const mapped = productsByHandle.get(product.handle);
    if (mapped && mapped.variantPrices.get(variantId) === 0) return;
    clickOverrides.set(product.handle, product);
    scheduleDecorate();
  }

  // Same refresh dcg-cart-bridge.js does after its own add (:62-71). StorePass
  // looks for <cart-notification>/<cart-drawer>, which this theme doesn't have.
  function refreshCart() {
    try {
      if (typeof window.adjustCartDropDown === 'function') {
        window.adjustCartDropDown();
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } catch (err) {
      console.warn('[DCG guard] cart refresh failed:', err);
    }
    // Always dispatch cart:updated so dcg-cart-enforcer.js runs its drawer audit.
    try { document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true })); } catch (_) {}
  }

  async function guardedAdd(args, formData) {
    try {
      const variantId    = String(formData.get('id') || '').trim();
      const requestedQty = Number(formData.get('quantity')) || 1;
      const sectionsUrl  = formData.get('sections_url');
      let quantity = requestedQty;

      const product = await resolveProduct(variantId, sectionsUrl);

      // ── Tags unknown: never send blind. The product page applies the rules.
      if (!product) {
        const message = 'Please add this item from its product page.';
        const path = productPagePath(sectionsUrl);
        if (path) window.location.assign(path);
        else toast(message);
        return blockedResponse(422, message);
      }

      // ── Retail / coming-soon: cart disabled, same as the DCG card ─────────
      const state = ruleState(product.tags);
      if (state) {
        const message = blockMessage(state, product.title);
        toast(message);
        recordOverride(product, state);
        return blockedResponse(422, message);
      }

      // ── Price pending (D-SP-14): a $0.00 variant is never sent ────────────
      // Shopify's price when Shopify answered (it wins over StorePass's
      // index); the index's price only when Shopify could not be asked.
      const knownPrice = product.variantPrices ? product.variantPrices.get(variantId) : undefined;
      const cents = typeof knownPrice === 'number' ? knownPrice : null;
      if (pricePending(cents, product.tags)) {
        toast(PRICE_PENDING_MESSAGE);
        recordPriceOverride(product, variantId);
        return blockedResponse(422, PRICE_PENDING_MESSAGE);
      }

      // ── Pre-flight enforcement (as dcg-cart-bridge.js:13-34) ──────────────
      const enforcer = window.DCG.enforcer;
      if (enforcer && typeof enforcer === 'object') {
        let blockedMessage = null;
        try {
          // The enforcer's registry is filled from DCG cards and there are none
          // on a StorePass page, so hand it this variant's tags first — without
          // them preflight finds no limit:N and passes everything. The price
          // goes with them (D-SP-14), so preflight has no need to ask Shopify
          // for it again.
          if (typeof enforcer.registerVariant === 'function') {
            enforcer.registerVariant(variantId, product.tags, null, cents);
          }
          const check = await enforcer.preflight(variantId, quantity);
          if (check.blocked) {
            blockedMessage = check.message || 'Purchase limit reached.';
          } else {
            // Qty was reduced — show reason, but still proceed with the add
            if (check.message) toast(check.message);
            quantity = Number(check.qty) || quantity;
          }
        } catch (enforceErr) {
          // Failure inside preflight: log and allow the add (bridge behaviour)
          console.warn('[DCG] enforcer preflight error — allowing add:', enforceErr);
        }
        if (blockedMessage) {
          toast(blockedMessage);
          return blockedResponse(422, blockedMessage);
        }
      }

      // ── Send. StorePass's own request goes out untouched unless preflight
      //    reduced the quantity, in which case a copy of its form is sent.
      let sendArgs = args;
      if (quantity !== requestedQty) {
        const adjusted = new FormData();
        formData.forEach((value, key) => {
          adjusted.append(key, key === 'quantity' ? String(quantity) : value);
        });
        sendArgs = [args[0], Object.assign({}, args[1], { body: adjusted })];
      }

      let res;
      try {
        res = await upstreamFetch.apply(window, sendArgs);
      } catch (networkErr) {
        console.warn('[DCG guard] /cart/add.js request failed:', networkErr);
        return blockedResponse(503, 'Add to cart failed. Please try again.');
      }

      if (res.ok) refreshCart();
      return res;

    } catch (err) {
      // Unexpected failure in the guard itself: fail closed, never throw.
      console.warn('[DCG guard] add stopped after a guard error:', err);
      const message = 'Please add this item from its product page.';
      toast(message);
      return blockedResponse(422, message);
    }
  }

  // ═════════════════════════════════════════════════════════════════════════
  // §D  CARD-STYLE TRIPWIRE
  // Everything above is built for StorePass's "modern-simple" card. The card
  // is picked by one dashboard setting (product_item_style), outside the
  // theme. Other values bring in cards that don't use Shopify's cart: the
  // bundle's default links to cardhaus.com/cart.php, and its fallback card
  // POSTs to /cart.php (BigCommerce). dcg-storepass.css hides those links;
  // here the /cart.php request is stopped and the setting is reported once.
  // ═════════════════════════════════════════════════════════════════════════

  const EXPECTED_CARD_STYLE = 'modern-simple';
  let cardStyleChecked = false;

  // `store` is the settings object the bundle is about to use.
  function checkCardStyle(store) {
    if (cardStyleChecked || !store || typeof store !== 'object') return;
    cardStyleChecked = true;
    const style = store.search_settings ? store.search_settings.product_item_style : undefined;
    if (style === EXPECTED_CARD_STYLE) return;
    console.warn('[DCG guard] StorePass product_item_style is ' +
      (style == null || style === '' ? '(unset)' : JSON.stringify(style)) +
      ', expected "' + EXPECTED_CARD_STYLE + '". Result cards may not use the Shopify cart. ' +
      'Check the card style in the StorePass dashboard.');
  }

  // The bundle takes its settings from one of three places: a local settings
  // file (#storepass-search-settings-json, none in this theme), the
  // storepass_store cookie it caches them in for 5 minutes, or a request to
  // /saas/store/settings. The two requests are seen by the fetch wrapper; the
  // cookie makes no request, so it is read here, the same way the bundle does.
  function localSettingsUrl() {
    const el = document.getElementById('storepass-search-settings-json');
    const url = el && el.getAttribute('data-url');
    try { return url ? new URL(url, window.location.href).href : null; }
    catch (_) { return null; }
  }

  function checkCardStyleFromCookie() {
    if (localSettingsUrl()) return;
    try {
      const raw = document.cookie.split(';').find(c => c.trim().startsWith('storepass_store='));
      if (raw) checkCardStyle(JSON.parse(decodeURIComponent(raw.split('=')[1])));
    } catch (_) { /* unreadable cookie: the bundle will request the settings instead */ }
  }

  // `res` is a clone; the bundle keeps the original.
  function checkCardStyleFromResponse(res) {
    res.json().then(data => { checkCardStyle(data && data.store); recordKeptParameters(data && data.store); }).catch(() => {});
  }

  // DCG v2-8 (D-SP-23): which address parameters StorePass has been told to
  // keep, read from the settings it actually loaded: the local settings file,
  // or its own answer when that file could not be fetched. The filter panel
  // offers a group on one of these keys only when the key is in the list, so
  // when the page falls back to StorePass's own settings no group appears
  // that would do nothing. null until a settings answer has been read.
  let keptParameters = null;
  function recordKeptParameters(store) {
    try {
      const list = store && store.search_settings && store.search_settings.custom_data_filters;
      keptParameters = Array.isArray(list) ? list.map(x => (x && x.parameter) ? String(x.parameter) : '').filter(Boolean) : [];
      document.dispatchEvent(new CustomEvent('dcg:storepass-settings', { detail: { parameters: keptParameters.slice() } }));
    } catch (_) { /* never into StorePass */ }
  }

  // /cart.php is not a Shopify endpoint. The request is never sent. If it
  // names a product this page knows (product_id in the query or the body),
  // the customer goes to that product's page; otherwise nothing more happens.
  function blockedCartPhp(url, init) {
    try {
      let productId = url.searchParams.get('product_id');
      const body = init && init.body;
      if (!productId && body) {
        if (typeof body === 'string') productId = new URLSearchParams(body).get('product_id');
        else if (typeof body.get === 'function') productId = body.get('product_id');   // URLSearchParams, FormData
      }
      const handle = productId ? handleByProductId.get(String(productId)) : null;
      if (handle) window.location.assign('/products/' + encodeURIComponent(handle));
    } catch (err) {
      console.warn('[DCG guard] /cart.php request stopped; product not resolved:', err);
    }
    return Promise.resolve(blockedResponse(404, 'This store has no /cart.php. Please use the product page.'));
  }

  // ── fetch wrapper ─────────────────────────────────────────────────────────

  function requestUrl(input) {
    const raw = typeof input === 'string' ? input : ((input && input.url) || String(input));
    return new URL(raw, window.location.href);
  }

  function classify(input, init) {
    const url = requestUrl(input);
    const method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();

    if (/\/cart\.php$/i.test(url.pathname)) return 'cartphp';

    // StorePass's API host is a remote setting (api_base_url), so match the path.
    if (method === 'GET' && /\/saas\/search\/?$/.test(url.pathname)) return 'search';
    if (method === 'GET' &&
        (/\/saas\/store\/settings\/?$/.test(url.pathname) || url.href === localSettingsUrl())) {
      return 'settings';
    }

    if (method === 'POST' &&
        url.origin === window.location.origin &&
        /\/cart\/add\.js$/.test(url.pathname) &&
        typeof FormData !== 'undefined' &&
        init && init.body instanceof FormData) {
      return 'add';
    }
    return null;
  }

  // ═════════════════════════════════════════════════════════════════════════
  // BRIDGE  Printing by bare tag (D-SP-20, D-SP-22, DCG v2-8)
  // The filter panel keeps the customer's printing in the address as
  // `printing=<tag>`; StorePass sends that key with its search and its search
  // ignores it. Here the bare BinderPOS tag is added to the request, so the
  // tag never enters StorePass's own state (its Sort throws on a tag read
  // from the address). dcg-storepass-filters.js decides whether a tag is
  // wanted (its games table; a bridge switched off there gives none).
  // Returns the address to request in place of StorePass's, or null.
  // ═════════════════════════════════════════════════════════════════════════
  function bridgedSearchUrl(input) {
    const filters = window.DCG && window.DCG.storepassFilters;
    if (!filters || typeof filters.tagsFor !== 'function') return null;
    if (typeof input !== 'string' && !(typeof URL !== 'undefined' && input instanceof URL)) return null;   // a Request object is left alone
    const url = new URL(String(input), window.location.href);
    const tag = filters.tagsFor(url.searchParams);
    if (!tag) return null;
    const have = String(url.searchParams.get('tags') || '').split(',').map(t => t.trim()).filter(Boolean);
    if (have.indexOf(tag) !== -1) return null;
    have.push(tag);
    url.searchParams.set('tags', have.join(','));
    return url.toString();
  }

  // ═════════════════════════════════════════════════════════════════════════
  // SET KEPT  (D-SP-39, PROPOSED; DCG v2-10-11 item 1a)
  // storepass.js's own Sort, In Stock Only and price search rebuild the
  // request from its own state (handleFilterSubmit), which holds no set when
  // the set came from the address, the filter panel's way in: the request
  // says set_name= (empty), and the search for the whole collection went
  // (by a real click, 16 OCT: One Piece "Adventure on Kami's Island" 111 ->
  // 1,935; Riftbound "Riftbound Promotional Cards" 29 -> 2,011;
  // docs/REPORT-v2-10-11.md §1). The set the customer chose is put back into
  // that request on the way out, as the Printing tag is above: the filter
  // panel's (dcg-storepass-filters.js wantedSet()), or, without the panel,
  // the set of storepass.js's last listing search that held one (read from
  // the address on the way in). Only a listing search (it names a product
  // line) that carries set_name empty is touched. One with no set_name at
  // all (the set taken off by its pill, Clear, Back to an address with
  // none) goes as it is. The address and StorePass's own pill come back by
  // the panel's set repair (§F there), which stays as the net.
  // ═════════════════════════════════════════════════════════════════════════
  let lastSet = null;
  function chosenSet() {
    const filters = window.DCG && window.DCG.storepassFilters;
    if (filters && typeof filters.wantedSet === 'function') return filters.wantedSet() || null;
    return lastSet;
  }
  function settedSearchUrl(input) {
    if (typeof input !== 'string' && !(typeof URL !== 'undefined' && input instanceof URL)) return null;   // a Request object is left alone
    const url = new URL(String(input), window.location.href);
    const p = url.searchParams;
    if (p.get('return_type') || !p.get('product_line')) return null;
    if (!p.has('set_name')) { lastSet = null; return null; }
    if (p.get('set_name')) { lastSet = p.get('set_name'); return null; }
    const set = chosenSet();
    if (!set) return null;
    p.set('set_name', set);
    return url.toString();
  }

  // The card opens on the printing that was asked for (Cole, D-SP-22): a
  // tagged product HOLDS the printing, in stock or not. Its condition select
  // is put on a variant of that printing, one in stock if there is one, else
  // the first; StorePass then shows that variant, sold out when it is. Done
  // once for a card and a choice, so the customer's own pick afterwards
  // stands. No card is hidden and the result count is left alone.
  const PRINTING_ATTR = 'data-dcg-printing';
  const CONDITION_PREFIX = /^(Near Mint|Lightly Played|Moderately Played|Heavily Played|Damaged)\s*/i;
  const printingOfTitle = title => String(title || '').replace(CONDITION_PREFIX, '').trim() || 'Normal';
  function openOnPrinting(card, handle) {
    const filters = window.DCG && window.DCG.storepassFilters;
    const tag = (filters && typeof filters.chosenTag === 'function') ? filters.chosenTag() : null;
    if (!tag || !handle) { if (card.hasAttribute(PRINTING_ATTR)) card.removeAttribute(PRINTING_ATTR); return; }
    const key = handle + '|' + tag;
    if (card.getAttribute(PRINTING_ATTR) === key) return;
    const select = card.querySelector(SELECT_SELECTOR);
    if (!select) return;                                   // one variant: nothing to open
    let first = -1, stocked = -1;
    for (let i = 0; i < select.options.length; i++) {
      let v = null;
      try { v = JSON.parse(select.options[i].value); } catch (_) { v = null; }
      if (!v || typeof v !== 'object' || printingOfTitle(v.title) !== tag) continue;
      if (first === -1) first = i;
      if (stocked === -1 && typeof v.inventory_quantity === 'number' && v.inventory_quantity > 0) stocked = i;
    }
    card.setAttribute(PRINTING_ATTR, key);
    const want = stocked !== -1 ? stocked : first;
    if (want === -1 || select.selectedIndex === want) return;
    select.selectedIndex = want;
    select.dispatchEvent(new Event('change', { bubbles: true }));   // StorePass's own handler redraws the card
  }

  window.fetch = function dcgStorePassGuardFetch(input, init) {
    let kind = null;
    try { kind = classify(input, init); } catch (_) { kind = null; }

    if (kind === 'search') {
      // BRIDGE (D-SP-22): a search that carries `printing=Foil` leaves with
      // `tags=Foil` as well. Anything unexpected: the request goes as it came.
      let args = arguments;
      try { const bridged = bridgedSearchUrl(input); if (bridged) args = [bridged, init]; } catch (_) { args = arguments; }
      // v2-10-11 (item 1a; D-SP-39): the chosen set, when storepass.js's own rebuild left it out
      try { const withSet = settedSearchUrl(args[0]); if (withSet) args = [withSet, init]; } catch (_) {}
      // v2-10-10 (item 1a): a short sort name leaves as its label; v2-10-11 (item 3): in_stock=undefined as true
      try { const labelled = labelledSearchUrl(args[0]); if (labelled) args = [labelled, init]; } catch (_) {}
      const pending = upstreamFetch.apply(window, args);
      // StorePass gets this very promise back. Our handler is attached first,
      // so the clone is taken before StorePass starts reading the body.
      let asked = null;
      try { asked = requestUrl(args[0]); } catch (_) { asked = null; }
      // v2-10-10 (item 1b): storepass.js's own count request, seen as it leaves (before its page's answer comes)
      try { if (asked && asked.searchParams.get('with_count') === 'true' && !asked.searchParams.get('return_type')) countsAsked.add(keep(countsAsked, pageKey(asked))); } catch (_) {}
      inStockFirstFor(asked);           // v2-10-8 (item 2): before StorePass reads its answer
      // v2-10-4 (D-SP-37): the search is announced as started, and as failed if
      // it is refused, is not a 200, or has no answer after 8 seconds
      let watch = null;
      try { watch = watchSearch(asked); } catch (_) { watch = null; }
      pending.then(res => {
        try { if (watch) watch.answered(res); } catch (_) {}
        try { recordSearchResponse(res.clone(), asked); } catch (_) {}
      }, () => { try { if (watch) watch.failed(); } catch (_) {} });
      return pending;
    }

    if (kind === 'settings') {
      const pending = upstreamFetch.apply(window, arguments);
      pending.then(res => {
        try { checkCardStyleFromResponse(res.clone()); } catch (_) {}
        keepSettings(res);              // v2-10-8 (item 2): this runs before storepass.js's own handler reads it
      }, () => {});
      return pending;
    }

    if (kind === 'add') return guardedAdd(arguments, init.body);

    if (kind === 'cartphp') return blockedCartPhp(requestUrl(input), init);

    return upstreamFetch.apply(window, arguments);
  };

  // v2-10-8 (item 2): no in-stock-first reorder under the two price sorts.
  // StorePass's setting in_stock_first_per_page (true in the local settings
  // file) makes storepass.js put the in-stock cards of each collection page
  // first, whatever the sort; under "Price: Low-High" a row read $1.00,
  // $0.35, $0.35, $0.30, $1.05, $0.40, $166.65 (Cowork, 15 OCT). The setting
  // is one for every sort, and storepass.js is not edited (D-SP-02). It reads
  // the setting from the object the settings file was parsed into, when each
  // answer comes. That object is kept here as it is parsed, and the setting
  // is set when each search leaves: off under a price sort, the file's own
  // value under every other. Nothing else in it is touched.
  const PRICE_SORT = /^Price:/i;
  let spSearchSettings = null;           // the search_settings object storepass.js holds
  let inStockFirst = null;               // its in_stock_first_per_page as the file has it
  function keepSettings(res) {
    try {
      const own = res.json;
      res.json = function () {
        return own.apply(res, arguments).then(obj => {
          try {
            const ss = obj && obj.store && obj.store.search_settings;
            if (ss && typeof ss === 'object' && spSearchSettings === null) { spSearchSettings = ss; inStockFirst = ss.in_stock_first_per_page; }
          } catch (_) {}
          return obj;
        });
      };
    } catch (_) {}
  }
  // (Seen on the draft, 15 OCT 02:12: after a price-sorted page, storepass.js asks for its filter options three times
  // with return_type=custom_filter and no sort. Those draw no cards and leave the setting as it is.)
  function inStockFirstFor(url) {
    try {
      if (!spSearchSettings || inStockFirst !== true || !url || url.searchParams.has('return_type')) return;
      spSearchSettings.in_stock_first_per_page = PRICE_SORT.test(url.searchParams.get('sort') || '') ? false : inStockFirst;
    } catch (_) {}
  }

  // For checking on the draft theme: DCG.storepassGuard._getProducts()
  // (StorePass's index) and ._getOverrides() (click-time Shopify answers).
  // v2-10-8 (item 3a): one search made by the theme itself (the safety net's check of page 2), through the
  // fetch StorePass's own searches go through, but not announced: neither the net nor the pager takes it for
  // the listing's own search. Read only; the answer is { ok, products: [keys], cursor } or null when it failed.
  function quietSearch(href, patience) {
    return new Promise(resolve => {
      let done = false;
      const end = v => { if (!done) { done = true; resolve(v); } };
      setTimeout(() => end(null), patience || SEARCH_PATIENCE);
      let pending;
      try { pending = upstreamFetch.call(window, href, { credentials: 'omit' }); } catch (_) { end(null); return; }
      pending.then(res => (res && res.ok ? res.json() : null)).then(data => {
        if (!data || typeof data !== 'object' || !Array.isArray(data.products)) { end(null); return; }
        end({ ok: true, products: data.products.map(productKey), cursor: !!(data.nextPageParameters && data.nextPageParameters.page_info) });
      }, () => end(null));
    });
  }

  window.DCG.storepassGuard = {
    quietSearch:   quietSearch,
    pageSize:      listingSize,           // v2-10-11 (item 2): the listing's page size, for assets/dcg-storepass-paging.js
    inStockFirst:  () => (spSearchSettings ? { file: inStockFirst, now: spSearchSettings.in_stock_first_per_page } : null),
    decorate:      scheduleDecorate,
    lastResults:   () => ({ productTypes: lastResults.productTypes.slice(), products: lastResults.products }),
    keptParameters: () => (keptParameters === null ? null : keptParameters.slice()),
    _getProducts:  () => new Map(productsByHandle),
    _getOverrides: () => new Map(clickOverrides)
  };

  checkCardStyleFromCookie();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchListing);
  } else {
    watchListing();
  }
})();
